import type { AnySchema } from 'yup'

/**
 * Check whether a Yup schema field is required (supports nested field paths).
 * @param schema - Yup schema (typically an object schema).
 * @param fieldPath - Dot-separated field path (e.g. "shippingAddress.fullName").
 * @returns True if the field has a "required" test, otherwise false.
 */
export const isYupFieldRequired = (schema: AnySchema, fieldPath: string): boolean => {
  const segments = fieldPath.split('.')
  let field: unknown = schema.describe()

  for (const segment of segments) {
    if (
      typeof field !== 'object' ||
      field == null ||
      !('fields' in field) ||
      typeof (field as { fields?: unknown }).fields !== 'object' ||
      (field as { fields?: Record<string, unknown> }).fields == null
    ) {
      return false
    }

    field = (field as { fields: Record<string, unknown> }).fields[segment]
  }

  if (field == null || typeof field !== 'object') return false

  const tests = (field as { tests?: Array<{ name?: string }> }).tests
  if (!Array.isArray(tests)) return false

  return tests.some((test) => test?.name === 'required')
}
